import React, { useEffect, useState } from "react";
import { MessageCircle, ArrowRight, Phone } from "lucide-react";
import { wa, WHATSAPP } from "../mock";

export default function MobileCTABar() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const targets = [
      document.getElementById("contact"),
      document.getElementById("corporate-buyback-banner"),
      document.getElementById("enquiry"),
      document.querySelector("[data-testid='inquiry-form']"),
    ].filter(Boolean);
    if (!targets.length || typeof IntersectionObserver === "undefined") return;
    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setHidden(visible.size > 0);
      },
      { threshold: 0 }
    );
    targets.forEach((target) => io.observe(target));
    return () => io.disconnect();
  }, []);

  const goContact = (e) => {
    const el =
      document.getElementById("contact") ||
      document.getElementById("enquiry") ||
      document.querySelector("[data-testid='inquiry-form']");
    e.preventDefault();
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.open(wa("Hi Kapatia, please share your best price and availability."), "_blank", "noopener");
  };

  return (
    <>
      {/* Spacer so the fixed bar never hides the footer on mobile */}
      <div className="h-16 sm:hidden" aria-hidden="true" />
      <div data-testid="mobile-cta-bar"
           aria-hidden={hidden}
           className={`fixed inset-x-0 bottom-0 z-40 flex items-stretch gap-2 border-t px-3 py-2.5 transition-transform duration-300 sm:hidden ${hidden ? "translate-y-full pointer-events-none" : "translate-y-0"}`}
           style={{
             background: "rgba(255,253,247,0.92)",
             backdropFilter: "blur(12px)",
             WebkitBackdropFilter: "blur(12px)",
             borderColor: "var(--line)",
             boxShadow: "0 -8px 24px rgba(45,106,79,0.10)",
             paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))"
           }}>
        <a href={`tel:+${WHATSAPP}`} data-testid="mobile-cta-call" tabIndex={hidden ? -1 : undefined}
           className="kp-button kp-button--compact flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full border-2 bg-white px-2.5 py-2.5 font-heading text-[13px] font-bold"
           style={{ borderColor: "var(--green-800)", color: "var(--green-900)" }}>
          <Phone size={16} /> Call
        </a>
        <a href={wa()} target="_blank" rel="noopener noreferrer" data-testid="mobile-cta-whatsapp" tabIndex={hidden ? -1 : undefined}
           className="kp-button kp-button--compact flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full border-2 bg-white px-2.5 py-2.5 font-heading text-[13px] font-bold"
           style={{ borderColor: "var(--green-800)", color: "var(--green-900)" }}>
          <MessageCircle size={16} /> WhatsApp
        </a>
        <a href="#contact" onClick={goContact} data-testid="mobile-cta-quote" tabIndex={hidden ? -1 : undefined}
           className="kp-button kp-button--compact flex flex-[1.25] items-center justify-center gap-1 whitespace-nowrap rounded-full px-2.5 py-2.5 font-heading text-[13px] font-bold text-white"
           style={{
             background: "linear-gradient(135deg, #ff3f1f 0%, var(--orange-500) 58%, #ff9f1c 100%)",
             boxShadow: "0 10px 22px rgba(230,81,22,0.28)"
           }}>
          Best Price <ArrowRight size={15} />
        </a>
      </div>
    </>
  );
}
